import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User, UserPermission, noAuthentification } from '@elio/emanager-front/auth/model';
import { BACKEND_URL } from '@elio/shared/models';
import { Observable } from 'rxjs';

//use as a type
type TokenValidation = 'TOKEN_VALID' | 'TOKEN_EXPIRED' | 'TOKEN_INVALID';

//DO NOT extends AbtractService because of circular dependencies
@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) {}

  private USER_URL = `${BACKEND_URL}/user`;

  getUser(jwtAccessToken: string): Observable<User> {
    const options = {
      context: noAuthentification(),
      headers: new HttpHeaders({
        Authorization: `Bearer ${jwtAccessToken}`,
      }),
    };
    return this.http.get<User>(this.USER_URL, options);
  }

  hasPermission(user: User, permission: UserPermission): boolean {
    return user.isSuperAdmin || user.permissions.some((userPermission) => userPermission.name === permission);
  }

  resetMyPassword(email: string): Observable<void> {
    return this.http.put<void>(`${this.USER_URL}/reset-my-password`, email, {
      context: noAuthentification(),
    });
  }

  changeMyPassword(password: string, email: string, token: string): Observable<void> {
    const data = {
      password,
      email,
      token,
    };
    return this.http.post<void>(`${this.USER_URL}/change-my-password`, data);
  }

  getChangeMyPasswordTokenValidation(email: string, token: string): Observable<TokenValidation> {
    const data = {
      email,
      token,
    };
    return this.http.post<TokenValidation>(`${this.USER_URL}/is-change-my-password-token-valid`, data, {
      context: noAuthentification(),
    });
  }

  logout(): Observable<void> {
    return this.http.post<void>(`${BACKEND_URL}/auth/logout`, null);
  }
}
